/** Remediation requests list — active vs cancelled row styling and sort. */

import {
  getStatusMeta,
  getStatusRowGroup,
  isInactiveStatus,
  STATUS_ROW_GROUP,
} from "./statusColors";

export const formatRequestRef = (id) =>
  id != null && id !== "" ? `R-${id}` : "—";

export const CANCELLED_REQUEST_STATUSES = new Set(["CANCELLED", "ABANDONED"]);

export const isCancelledRequest = (request) =>
  CANCELLED_REQUEST_STATUSES.has(request?.status);

const INACTIVE_ROW = {
  rowBg: "#e2e8f0",
  hoverBg: "#cbd5e1",
  textColor: "#64748b",
  opacity: 0.88,
};

const GROUP_ROW_DEFAULTS = {
  [STATUS_ROW_GROUP.ACTIVE]: {
    hoverBg: "#f1f5f9",
  },
  [STATUS_ROW_GROUP.ATTENTION]: {
    hoverBg: null,
  },
  [STATUS_ROW_GROUP.SUCCESS]: {
    hoverBg: "#dcfce7",
  },
  [STATUS_ROW_GROUP.FAILURE]: {
    hoverBg: "#fce7f3",
  },
  [STATUS_ROW_GROUP.INACTIVE]: INACTIVE_ROW,
};

/** Non-cancelled rows first; preserve relative order within each group. */
export const sortRequestsActiveFirst = (items) => {
  if (!Array.isArray(items)) return [];
  return [...items].sort((a, b) => {
    const aRank = isCancelledRequest(a) ? 1 : 0;
    const bRank = isCancelledRequest(b) ? 1 : 0;
    return aRank - bRank;
  });
};

export const getRequestRowSx = (request) => {
  const status = request?.status;
  const meta = getStatusMeta(status);
  const group = getStatusRowGroup(status);
  const inactive = isInactiveStatus(status);
  const groupDefaults = GROUP_ROW_DEFAULTS[group] || GROUP_ROW_DEFAULTS[STATUS_ROW_GROUP.ACTIVE];

  const rowBg = inactive ? INACTIVE_ROW.rowBg : meta.rowBg || "#ffffff";
  const hoverBg = inactive
    ? INACTIVE_ROW.hoverBg
    : groupDefaults.hoverBg || meta.bg || "#f8fafc";

  return {
    cursor: "pointer",
    backgroundColor: rowBg,
    ...(inactive
      ? {
          opacity: INACTIVE_ROW.opacity,
          "& .MuiTableCell-root": { color: INACTIVE_ROW.textColor },
          "& .MuiTypography-root": { color: "inherit" },
          "& .MuiCheckbox-root": { color: "#94a3b8" },
        }
      : {}),
    "&:hover": {
      backgroundColor: hoverBg,
      ...(inactive ? { opacity: 1 } : {}),
    },
  };
};
